import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { api, errCode } from "@/lib/api";
import { Field } from "@/pages/Checkout";

export function Policy() {
  const { t, pick } = useI18n();
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/policy").then((r) => setP(r.data)); }, []);
  if (!p) return null;
  const r = p.returns;
  const start = t(`policy.start_${r.window_start}`);
  const blocks = [
    ["returns_title", [t("policy.mind", { days: r.change_of_mind_days, start }), t("policy.mind_cond"), t("policy.excluded")]],
    ["defect_title", [t("policy.defect", { days: r.defect_claim_days, start }), t("policy.defect_types"), t("policy.misuse")]],
    ["refund_title", [t("policy.refund_1"), t("policy.refund_2"), t("policy.refund_3")]],
    ["cancel_title", [t("policy.cancel_1"), t("policy.cancel_2"), t("policy.cancel_3")]],
    ["warranty_title", [t("policy.warranty_1"), t("policy.warranty_2")]],
  ];
  return (
    <div className="container-x py-12 max-w-3xl space-y-8" data-testid="policy-page">
      <div className="space-y-2"><h1 className="text-3xl sm:text-4xl font-bold tracking-tight">{t("policy.title")}</h1><p className="muted">{t("policy.sub")}</p></div>
      {blocks.map(([k, lines]) => <section key={k} className="card p-6 space-y-3"><h2 className="text-xl font-semibold">{t(`policy.${k}`)}</h2><ul className="space-y-2 text-sm leading-relaxed list-disc ps-5">{lines.map((l) => <li key={l}>{l}</li>)}</ul></section>)}
      {pick(r.conditions) && <section className="card p-6 space-y-2"><h2 className="text-xl font-semibold">{t("policy.extra_conditions")}</h2><p className="text-sm whitespace-pre-line leading-relaxed">{pick(r.conditions)}</p></section>}
      <p className="text-sm muted">{t("policy.statutory")}</p>
    </div>
  );
}

export function Support() {
  const { t } = useI18n();
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "", order_number: "" });
  const [sent, setSent] = useState(false);
  const on = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => { e.preventDefault(); try { await api.post("/support/messages", f); setSent(true); } catch (e2) { toast.error(t(`errors.${errCode(e2)}`)); } };
  return (
    <div className="container-x py-12 grid lg:grid-cols-[1fr_1.3fr] gap-8" data-testid="support-page">
      <div className="space-y-4"><h1 className="text-3xl sm:text-4xl font-bold tracking-tight">{t("support.title")}</h1><p className="muted leading-relaxed">{t("support.sub")}</p>
        <a href="mailto:onexsupportx@gmail.com" className="card p-5 flex items-center gap-3 hover:border-[#2563EB]"><Mail className="w-5 h-5 text-[#2563EB]" /><span className="font-medium">onexsupportx@gmail.com</span></a></div>
      {sent ? <div data-testid="support-sent" className="card p-10 text-center space-y-2"><p className="text-lg font-semibold">{t("support.sent")}</p><p className="muted text-sm">{t("support.sent_sub")}</p></div> :
        <form onSubmit={submit} className="card p-6 space-y-4">
          <div className="grid sm:grid-cols-2 gap-4"><Field label={t("checkout.name")} testid="support-name" required minLength={2} value={f.name} onChange={on("name")} /><Field label={t("checkout.email")} testid="support-email" required type="email" value={f.email} onChange={on("email")} /></div>
          <div className="grid sm:grid-cols-2 gap-4"><Field label={t("support.subject")} testid="support-subject" required minLength={2} value={f.subject} onChange={on("subject")} /><Field label={t("support.order_optional")} testid="support-order" value={f.order_number} onChange={on("order_number")} /></div>
          <label className="block"><span className="label">{t("support.message")}</span><textarea data-testid="support-message" required minLength={5} className="textarea" value={f.message} onChange={on("message")} /></label>
          <button data-testid="support-submit-btn" className="btn-primary w-full">{t("common.send")}</button>
        </form>}
    </div>
  );
}

export default Policy;
